// TODO: (Taiga UI migration) TuiCarousel is deprecated. Migrate to the new variant TuiCarousel from @taiga-ui/core. See https://taiga-ui.dev/components/carousel
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

/* ============================
   CDK
============================ */

import {
  TuiFilterPipe,
  TuiMapperPipe,
} from '@taiga-ui/cdk';

/* ============================
   CORE
============================ */

import { TuiDropdown,  TuiFormatNumberPipe, TuiDataList, TuiLoader, 
  TuiNumberFormat, TuiLabel, TuiGroup, TuiHint, 
  TuiNotification, TuiIcon, TuiError, TuiButton, TuiDialog, TuiInput, TuiFilterByInputPipe, TuiCarousel } from '@taiga-ui/core';

/* ============================
   LAYOUT
============================ */

import {
  TuiCard,
  TuiCardLarge,
  TuiCardMedium
} from '@taiga-ui/layout';



/* ============================
   ADDON COMMERCE
============================ */

import {
  TuiAmountPipe,
  TuiCurrencyPipe,
} from '@taiga-ui/addon-commerce';


/* ============================
   ADDON MOBILE
============================ */

import {
  TuiMobileCalendar,
  TuiPullToRefresh,
  TuiSheetDialog,
  TuiTabBar
} from '@taiga-ui/addon-mobile';

import {TuiAppBar, TuiFloatingContainer, TuiHeader} from '@taiga-ui/layout';

import { TuiSelect, TuiAvatar, TuiStringifyContentPipe, TuiChevron, TuiDataListWrapper, 
  TuiMultiSelect, TuiBadge, TuiChip, TuiFiles, TuiFile, TuiInputFiles, 
  TuiHighlight, TuiInputDateRange, TuiCalendarRange, TuiComboBox,
   TuiTextarea, TuiInputDate, TuiTabs, TuiSwitch, TuiTooltip, 
   TuiPagination, TuiInputNumber, TuiInputChip, TuiRadioList,
    TuiPush, TuiBadgedContent, TuiInputPhoneInternational,
    TuiBlock, TuiInputMonth, TuiFlagPipe, TuiAccordion } from '@taiga-ui/kit';
/* ============================
   ADDON TABLE
============================ */

import {
  TuiTablePagination,
} from '@taiga-ui/addon-table';

/* ============================
   EVENT PLUGINS
============================ */

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    TuiFilterPipe,
    TuiMapperPipe,

    ...TuiDropdown,
    TuiFlagPipe,
    TuiAccordion,
    TuiFormatNumberPipe,
    TuiInput,
    TuiCardMedium,
    TuiCardLarge,
    TuiDataList,
    TuiLoader,
    TuiNumberFormat,
    TuiLabel,
    TuiGroup,
    TuiHint,
    TuiNotification,
    TuiIcon,
    TuiError,
    TuiButton,
    TuiDialog,
    TuiAmountPipe,
    TuiCurrencyPipe,

    TuiMobileCalendar,
    TuiPullToRefresh,
    TuiSheetDialog,
    ...TuiTabBar,
    TuiAppBar, TuiFloatingContainer, TuiHeader,
    TuiAvatar,
    TuiFilterByInputPipe,
    TuiCarousel,
    ...(TuiSelect as unknown as any[]),
    TuiStringifyContentPipe,
    TuiChevron,
    TuiDataListWrapper,
    TuiTablePagination,
    TuiMultiSelect,
    TuiBadge,
    TuiChip,
    TuiFiles,
    TuiFile,
    TuiInputFiles,
    TuiHighlight,
    TuiInputDateRange,
    TuiCalendarRange,
    TuiComboBox,
    TuiTextarea,
    TuiInputDate,
    TuiTabs,
    TuiSwitch,
    TuiTooltip,
    TuiPagination,
    TuiInputNumber,
    TuiInputChip,
    TuiRadioList,
    TuiPush,
    TuiBadgedContent,
    TuiInputPhoneInternational,
    TuiBlock,
    TuiInputMonth 
  ],
  exports: [


    TuiFilterPipe,
    TuiMapperPipe,
    ...TuiDropdown,
    TuiFlagPipe,
    TuiAccordion,
    TuiFormatNumberPipe,
    TuiInput,
    TuiCardMedium,
    TuiCardLarge,
    TuiDataList,
    TuiAmountPipe,
    TuiCurrencyPipe,
    TuiLoader,
    TuiNumberFormat,
    TuiLabel,
    TuiGroup,
    TuiHint,
    TuiNotification,
    TuiIcon,
    TuiError,
    TuiButton,
    TuiDialog,
    TuiMobileCalendar,
    TuiPullToRefresh,
    TuiSheetDialog,
    ...TuiTabBar,
    TuiAppBar, TuiFloatingContainer, TuiHeader,
    TuiAvatar,
    TuiFilterByInputPipe,
    TuiCarousel,
    ...(TuiSelect as unknown as any[]),
    TuiStringifyContentPipe,
    TuiChevron,
    TuiDataListWrapper,
    TuiTablePagination,
    TuiMultiSelect,
    TuiBadge,
    TuiChip,
    TuiFiles,
    TuiFile,
    TuiInputFiles,
    TuiHighlight,
    TuiInputDateRange,
    TuiCalendarRange,
    TuiComboBox,
    TuiTextarea,
    TuiInputDate,
    TuiTabs,
    TuiSwitch,
    TuiTooltip,
    TuiPagination,
    TuiInputNumber,
    TuiInputChip,
    TuiRadioList,
    TuiPush,
    TuiBadgedContent,
    TuiInputPhoneInternational,
    TuiBlock,
    TuiInputMonth

  ],

  providers: [
  ],
})
export class ALL_TAIGA_UI_MODULES { }